<div class="mainGiftCardPreview">
  <router-outlet></router-outlet>
</div>